'use strict';
import angular from 'angular';
import './scripts/packages.ctrls';
import PackagesHtmlUrl from './views/Packages.html';
import PackagesAddHtmlUrl from './views/PackagesAdd.html';
import './scripts/packages.services';

angular.module('Packages', [
    'packages.ctrls',
    'packages.services',
])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('Packagesview', {
                parent: 'layout',
                url: '/admin/Packages',
                templateUrl: PackagesHtmlUrl,
                controller: 'PackagesController',
            })
            .state('Packagesadd', {
                parent: 'layout',
                url: '/admin/Packages',
                templateUrl: PackagesAddHtmlUrl,
                controller: 'PackagesAddController',
            })
            .state('Packagesedit', {
                parent: 'layout',
                url: '/admin/Packages',
                params:{
                    packages:null
                },
                templateUrl: PackagesAddHtmlUrl,
                controller: 'PackagesEditController',
            })
            
    }]);